import Styles from './PostPreviewModal.module.scss'
import { DesignChannel } from 'components/NewFileModal/Types'
import { Button } from 'blaze-ui/Button'
import { Calendar2, Send1 } from 'blaze-ui/icons'
import { PostStatusPropertyValue } from 'api/clients/PropertyClient'
import dayjs from 'dayjs'
import { PostValidations } from './components/PostValidations'
import { useModals } from 'almanac-ui/Modal'
import { InstagramStoryWarning } from './components/InstagramStoryWarning'
import { usePostPreviewContext } from './PostPreviewContext'
import { usePublishScheduledPost } from 'hooks/queries/scheduledPosts/usePublishScheduledPost'

interface Props {
  fileId: string
  channel: DesignChannel
}

export const SchedulingButtons = ({ fileId, channel }: Props) => {
  const { closeAllModals } = useModals()
  const { scheduledPost, provider, providerName, dateTime, handleSchedule, isPostable } = usePostPreviewContext()

  const publishScheduledPost = usePublishScheduledPost({ onSuccess: closeAllModals })

  if (!scheduledPost || !provider || !providerName) return null

  const handlePost = async () => {
    publishScheduledPost.mutateAsync({ id: scheduledPost.id })
  }

  return (
    <div className={Styles.postButtons}>
      <PostValidations channel={channel} fileId={fileId} />
      <InstagramStoryWarning scheduledPost={scheduledPost} channel={channel} />
      <Button
        size="lg"
        variant="primary"
        frontIcon={Calendar2}
        onPress={async () => {
          if (!dateTime) return
          await handleSchedule(dateTime.toDate(), PostStatusPropertyValue.AutoPostScheduled)
          closeAllModals()
        }}
        isDisabled={!isPostable}
      >
        Schedule for {dayjs(dateTime).format('MMM D h:mma')}
      </Button>
      <Button size="lg" variant="secondary" frontIcon={Send1} onPress={handlePost} isDisabled={!isPostable}>
        Post Now
      </Button>
    </div>
  )
}
